import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { FabricDetailSearchCriteria, RestReadRequest } from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { PopupFabricModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";

class FabricExcelToErpImportUploadList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "FabricExcel To Erp Import Upload",
      isShowExitButton: true,
      isShowResetButton: false,
      criteria: new FabricDetailSearchCriteria(),
      isShowFabricExcelUploadModule: true,
      isShowFabricAfterExcelUploadModule: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      fabricStyleList: [],
      order: "asc",
      sortField: "",
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    if (this.state.is3PL === true) {
      this.state.pageTitle = "Item Excel To Erp Import Upload";
    } else {
      this.state.pageTitle = "FabricExcel To Erp Import Upload";
    }
    this.report_url = appData.reportURL;
  }
  showErrorMessage = (response) => {
    if (response.error != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_List: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let infoList = this.state.success_List;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          infoList.push(info.messageDescription)
        )
      );
      this.setState({ success_List: infoList });
      this.setState({
        alertMessage: infoList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
      error_list: [],
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      ProgressLoadingText: "",
    });
    ShowError("Error" + error);
  };
  uploadExcelFile = (e) => {
    this.hideAlertCallBack(false);
    let file = e.target.files[0];
    let fileName = file.name;
    let fileData = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", fileData);
    this.setState({ fileName: fileName });
    if (SecurityAccessManager.WebFabricExcelToERPImport_IsAccessible()) {
      FabricStyleService.webFabricDataInputExcelUpload(
        formData,
        this.uploadExcelResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  uploadExcelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      if (response.data.success == true) {
        this.getExcelData();
      }
    }
  };
  getExcelData = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Excel Data..",
    });
    let listRequest = new RestReadRequest();
    listRequest.companyCode = this.companyCode;
    listRequest.code = this.state.fileName;
    if (SecurityAccessManager.WebFabricExcelToERPImport_IsAccessible()) {
      ReportService.getWebEcomToErpWebImportFromExcel(
        listRequest,
        this.getExcelDataResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  getExcelDataResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let fabricStyleList = new Array();
      if (!isEmptyArray(response.data.resultBean.fabricStyleList)) {
        fabricStyleList = response.data.resultBean.fabricStyleList;
      }
      this.setState({
        fabricStyleList: fabricStyleList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.openFabricImportResultPage();
    } else {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg = "No FabricStyle Input Data to Load";
      } else {
        errMsg = "No Item Input Data to Load";
      }
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  openFabricImportResultPage = () => {
    this.setState({
      isShowFabricAfterExcelUploadModule: true,
      isShowFabricExcelUploadModule: false,
      isShowResetButton: true,
    });
  };
  closeFabricImportResultPage = () => {
    this.setState({
      isShowFabricExcelUploadModule: true,
      isShowFabricAfterExcelUploadModule: false,
      isShowResetButton: false,
    });
  };
  reset = () => {
    this.closeFabricImportResultPage();
    this.setState({ fabricStyleList: null });
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let fabricStyleList = this.state.fabricStyleList;
    if (sortField && !isEmptyArray(fabricStyleList)) {
      const sorted = [...fabricStyleList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ fabricStyleList: sorted });
    }
  };

  render() {
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.onModuleExit}
          reset={this.reset}
        />
        {this.state.isShowFabricExcelUploadModule && (
          <FabricExcelUploadModule uploadExcelFile={this.uploadExcelFile} />
        )}
        {this.state.isShowFabricAfterExcelUploadModule && (
          <FabricExcelAfterUploadModule
            {...this.state}
            handleSortingChange={this.handleSortingChange}
            is3PL={this.state.is3PL}
            order={this.state.order}
            sortField={this.state.sortField}
          />
        )}
      </div>
    );
  }
}
class FabricExcelUploadModule extends React.Component {
  constructor(props) {
    super(props);
  }
  loadExcel = (e) => {
    if (e.detail === 1) {
      const input = document.getElementById("file-input");
      if (input) {
        input.click();
      }
    }
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };

  render() {
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="2">
            <FormLabel>Select Input File</FormLabel>
          </Col>
          <Col sm="2">
            <Button id="fabric_Add_Button" onClick={(e) => this.loadExcel(e)}>
              Choose File
            </Button>
            <input
              type="file"
              id="file-input"
              style={{ display: "none" }}
              onChange={this.uploadExcelFile}
              accept=".doc,.docx,application/pdf, .xlsx, .xls, .csv, .txt"
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class FabricExcelAfterUploadModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowFabricModule: false,
      isShowFabricStyle: true,
    };
  }
  onPopupModalexit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricStyleModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricModule: true,
          moduleForPopup: (
            <PopupFabricModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalexit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricModule: isOpen,
      moduleForPopup: [],
    });
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };

  render() {
    let fabricStyleList = this.props.fabricStyleList;
    return (
      <div>
        <Row>
          <Col sm="1" className="title_text_div">
            <FormLabel>Result</FormLabel>
          </Col>
        </Row>
        <Row></Row>
        <Row>
          <Col sm="2">
            <FormLabel>No.of Updated items</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox value={fabricStyleList.length} disabled={true} />
          </Col>
        </Row>
        <Row></Row>
        <Row>
          <Col sm="2" className="title_text_div">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
        </Row>

        {this.state.isShowFabricStyle && (
          <div className="div_default">
            <Table id="fabrics_tables">
              <thead>
                <tr>
                  <th onClick={(e) => this.handleSortingChange(e, "code")}>
                    {this.props.is3PL ? "Item " : "FabricStyle"}
                    {this.props.order === "desc" &&
                    this.props.sortField === "code" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "description")}
                  >
                    {this.props.is3PL ? "Item Name" : "FabricStyle Name"}
                    {this.props.order === "desc" &&
                    this.props.sortField === "description" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "productTypeCode")
                    }
                  >
                    Product Type
                    {this.props.order === "desc" &&
                    this.props.sortField === "productTypeCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "currencyCode")}
                  >
                    Currency
                    {this.props.order === "desc" &&
                    this.props.sortField === "currencyCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "categoryCode")}
                  >
                    Category
                    {this.props.order === "desc" &&
                    this.props.sortField === "categoryCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "subCategoryCode")
                    }
                  >
                    Sub Category
                    {this.props.order === "desc" &&
                    this.props.sortField === "subCategoryCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "seasonCode")}
                  >
                    Seasion
                    {this.props.order === "desc" &&
                    this.props.sortField === "seasonCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "defaultLocationCode")
                    }
                  >
                    Default WH
                    {this.props.order === "desc" &&
                    this.props.sortField === "defaultLocationCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "inventoryUomCode")
                    }
                  >
                    Inv UOM
                    {this.props.order === "desc" &&
                    this.props.sortField === "inventoryUomCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "cost")}>
                    Cost
                    {this.props.order === "desc" &&
                    this.props.sortField === "cost" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "retailPrice")}
                  >
                    Retail Price
                    {this.props.order === "desc" &&
                    this.props.sortField === "retailPrice" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "wholesalePrice")
                    }
                  >
                    WholeSales Price
                    {this.props.order === "desc" &&
                    this.props.sortField === "wholesalePrice" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "description")}
                  >
                    Desc
                    {this.props.order === "desc" &&
                    this.props.sortField === "description" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>
                {fabricStyleList.map((data, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewFabricStyleModule(e, data.code)
                        }
                      >
                        {data.code}
                      </Button>
                    </td>
                    <td>{data.description}</td>
                    <td>{data.productTypeCode}</td>
                    <td>{data.currencyCode}</td>
                    <td>{data.categoryCode}</td>
                    <td>{data.subCategoryCode}</td>
                    <td>{data.seasonCode}</td>
                    <td>{data.defaultLocationCode}</td>
                    <td>{data.inventoryUomCode}</td>
                    <td className="text-right">{data.cost}</td>
                    <td className="text-right">{data.retailPrice}</td>
                    <td className="text-right">{data.wholesalePrice}</td>
                    <td>{data.description}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {fabricStyleList.length != 0 ? null : (
              <div className="no_Data">{"No Data"}</div>
            )}
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}

function FabricExcelToErpImportUpload(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App"></div>
      <FabricExcelToErpImportUploadList {...props} name="" />
      <br />
    </div>
  );
}

export default FabricExcelToErpImportUpload;
